module.exports = __webpack_public_path__ + "static/docs2-6a56d07f25ded1317c07df544df86f19.png";